angular.module('mailings')

    .controller('MailingFilesStelaModalCtrl', ['entity_type', 'entity_type_id','is_public', 'folderId', '$scope', '$uibModal', '$uibModalInstance', '$http', 'Restangular', 'LoginService', '$filter', '$timeout', '$rootScope', 'logService',
        function (entity_type, entity_type_id, is_public, folderId, $scope, $uibModal, $uibModalInstance, $http, Restangular, LoginService, $filter, $timeout, $rootScope, logService) {
            let currentFolderId = null;
            $scope.checkedFile = [];
            $scope.breadcrumb = function (folderId) {
                let options = { id: folderId, entity_type: entity_type, entity_type_id: entity_type_id };
                currentFolderId = folderId;
                Restangular.all("Folders").customGET("FoldersBreadcrumb", options).then(function (results) {
                    $scope.breadcrumbs = results;
                });
            };
            $scope.breadcrumb(currentFolderId);

            $scope.loadData = function (folderId) {
                let options = { folder_id: folderId, entity_type: entity_type, entity_type_id: entity_type_id, is_public: is_public };
                currentFolderId = folderId;
                logService.debug(is_public);
                Restangular.all("Folders").getList(options).then(function (results) {
                    logService.debug(results);
                    let fullFolderFiles = results;
                    $scope.foldersFiles = results;
                    $scope.breadcrumb(currentFolderId);//recargamos el breadcrumb
                });
            };

            $scope.loadData(currentFolderId);

            $scope.saveTemplate = function () {
                $scope.loadAttachments();
                $timeout(function () {
                    $uibModalInstance.close($scope.attachmentsStela);
                }, 500);
                
            };

        $scope.loadAttachments = function () {
            $scope.attachmentsStela = [];

            for (var key in $scope.checkedFile) {
                if ($scope.checkedFile[key].checked) {
                    Restangular.all("Files").getList({ uid: key }).then(function (res) {
                        $scope.attachmentsStela.push(res[0]);
                    });
                }
            }
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])
;